import { addSideEffects, initAction } from '@poa/state';
import moment from 'moment';
import { clone } from '../shared/clone';
import {
  changeColumnPreset,
  deletePreset,
  fetchFines,
  refreshFines,
  saveColumnPreset,
  setDates
} from './fines.actions';

const finesAvailablePresets = 'finesAvailablePresets-v2';
const finesLastSelectedPreset = 'finesLastSelectedPreset-v2';

addSideEffects(fetchFines, async (_, { actions, store, env }) => {
  try {
    const finesStatuses = await env.api.fines.fetchFinesStatuses();
    actions.finesActions.resetStatuses(finesStatuses);

    const finesGrouping = await env.api.fines.fetchFinesGrouping();
    actions.finesActions.resetGrouping(finesGrouping);

    const fines = await env.api.fines.fetchFines(
      store.fines.filters.startDate,
      store.fines.filters.endDate
    );

    actions.finesActions.fetchFinesSuccess(fines);
  } catch (e) {
    console.error(e);
    actions.finesActions.fetchFinesFailed();
    throw e;
  }
});

addSideEffects(refreshFines, async ({ filters, page }, { actions, env, store }) => {
  const fines = await env.api.fines.fetchFines(
    store.fines.filters.startDate,
    store.fines.filters.endDate,
    filters.map(filter => ({ type: filter.type, value: filter.value })),
    page
  );

  actions.finesActions.fetchFinesSuccess(fines);
});

// persist settings
addSideEffects(saveColumnPreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.fines.filters.columnSettings;

  await env.storage.setItem(finesAvailablePresets, clone(availablePresets));
  await env.storage.setItem(finesLastSelectedPreset, currentPresetId);
});

addSideEffects(deletePreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.fines.filters.columnSettings;

  await env.storage.setItem(finesAvailablePresets, clone(availablePresets));
  await env.storage.setItem(finesLastSelectedPreset, currentPresetId);
});

addSideEffects(changeColumnPreset, async (_, { env, store }) => {
  const { currentPresetId } = store.fines.filters.columnSettings;

  await env.storage.setItem(finesLastSelectedPreset, currentPresetId);
});

addSideEffects(setDates, async ({ startDate, endDate }, { env, store }) => {
  try {
    await env.storage.setItem('fines-dates', clone({ startDate, endDate }));
  } catch (e) {
    console.error(e);
    throw e;
  }
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const availablePresets = await env.storage.getItem(finesAvailablePresets);
  const presetId = await env.storage.getItem(finesLastSelectedPreset);
  const dates = await env.storage.getItem('fines-dates');

  if (dates) {
    actions.finesActions.setDates({
      startDate: dates.startDate ? moment(dates.startDate) : null,
      endDate: dates.endDate ? moment(dates.endDate) : null
    });
    return;
  }

  if (availablePresets && presetId) {
    actions.finesActions.resetColumnSettings({ presetId, availablePresets });
    return;
  }

  if (availablePresets) {
    actions.finesActions.resetColumnSettings({
      presetId: availablePresets[0].id, // default one
      availablePresets
    });
    return;
  }

  actions.finesActions.resetColumnSettings({
    presetId: store.fines.filters.columnSettings.availablePresets[0].id, // default one
    availablePresets: store.fines.filters.columnSettings.availablePresets
  });
});
